var DiagnosticCart = {
    init: function () {
        $(document).on("click", ".right .product-visage", function (e) {
            if (e.type == "touchend") {
                $(this).off("click");
            }


            var _this = $(this);
            if (_this.find(".icon--validate").hasClass("checked")) {
                DiagnosticCart.add_product(_this.find(".checkbox-prescription").attr("variant_id"), false);
            } else {
                DiagnosticCart.remove_product(_this.find(".checkbox-prescription").attr("variant_id"), false);

            }

        });
        $(document).on("click touchend", ".left .btn", function (e) {

            e.preventDefault();
            e.stopPropagation();


            if (e.type == "touchend") {
                $(this).off("click");
            }

            if ($(this).closest(".btn-container").hasClass("selected")) {
                DiagnosticCart.remove_product($(this).parent().find(".add-to-cart").attr("variant-id"), true);
            } else {
                DiagnosticCart.add_product($(this).parent().find(".add-to-cart").attr("variant-id"), true);
            }
        });


        setTimeout(function(){
            DiagnosticCart.init_button();
        }, 400)

    },
    init_button:function(){
        console.log("!!!!!! INIT BUTTONS !!!!!!!");
        $(".diagnostic-akrolab .right").find(".checkbox-prescription").each(function () {
            DiagnosticCart.add_product($(this).attr("variant_id"), true);
        })
    },
    add_product: function (pValue, _dispatch) {

console.log("ADD PRODUCT : " + $(".left .btn.add-to-cart").length + " // " +  $(".right .checkbox-prescription").length);
        $(".left .btn.add-to-cart").each(function () {
            if ($(this).attr("variant-id") == pValue) {
                $(this).closest(".btn-container").addClass("initialized selected");
            }
        });

        $(".right .checkbox-prescription").each(function () {
            if ($(this).attr("variant_id") == pValue) {
                $(this).closest(".product-visage").addClass("initialized selected");
            }
        })

        if (_dispatch) {
            $(".right .product-visage").each(function () {
                if ($(this).find(".checkbox-prescription").attr("variant_id") == pValue) {
                    $(this).trigger("click");
                }
            })
        }
    },
    remove_product: function (pValue, _dispatch) {


        $(".left .btn.add-to-cart").each(function () {
            if ($(this).attr("variant-id") == pValue) {
                $(this).closest(".btn-container").removeClass("selected");
            }
        })

        $(".right .checkbox-prescription").each(function () {
            if ($(this).attr("variant_id") == pValue) {
                $(this).closest(".product-visage").removeClass("selected");
            }
        })

        if (_dispatch) {
            $(".right .product-visage").each(function () {
                if ($(this).find(".checkbox-prescription").attr("variant_id") == pValue) {
                    $(this).trigger("click");
                }
            })
        }


        $("#cart__drawer .cart__item--container").each(function () {
            if ($(this).attr("variant-id") == pValue) {
                $(this).find(".remove--selector").trigger("click");
            }
        })
    }
}

$(window).on("load", function () {
    if ($(".diagnostic-akrolab").length) {
        DiagnosticCart.init();
    }
})